// extracted by mini-css-extract-plugin
export default {"border":"Highlights_border__5jc12","highlights":"Highlights_highlights__zKxd3","marquee":"Highlights_marquee__ux0Xx"};